
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCommissionMessages, sendCommissionMessage, markMessagesAsRead } from "@/services/commission.service";
import { CommissionMessage } from "@/types/commission.types";

// Get commission messages
export const useCommissionMessages = (requestId: string) => {
  return useQuery({
    queryKey: ['commission-messages', requestId],
    queryFn: () => getCommissionMessages(requestId),
    enabled: !!requestId,
    retry: 1,
    refetchInterval: 10000 // Refresh every 10 seconds
  });
};

// Send a commission message
export const useSendCommissionMessage = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (message: Omit<CommissionMessage, 'id' | 'created_at' | 'sender'>) => {
      return sendCommissionMessage(message);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['commission-messages', variables.commission_request_id] });
    }
  });
};

// Mark messages as read
export const useMarkMessagesAsRead = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ requestId, userId }: { requestId: string, userId: string }) => {
      return markMessagesAsRead(requestId, userId);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['commission-messages', variables.requestId] });
    }
  });
};
